import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usermaster',
  templateUrl: './usermaster.component.html',
  styleUrls: ['./usermaster.component.css']
})
export class UsermasterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
